// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3tVDZ","info":"UpdateTermsInfo_info__1PR_l"};